import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Download } from 'lucide-react';
import { adminAuthHeaders } from './adminHelpers';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminExportCsvButton = ({ resource }) => {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/admin/export/${resource}`, {
        headers: adminAuthHeaders(),
        credentials: 'include',
      });
      if (!res.ok) throw new Error(`Export failed (${res.status})`);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${resource}-${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      alert(`Export failed: ${e.message}`);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button
      type="button"
      variant="outline"
      onClick={download}
      disabled={busy}
      data-testid={`export-csv-${resource}-btn`}
    >
      <Download className="w-4 h-4 mr-1" /> {busy ? 'Exporting…' : 'Export CSV'}
    </Button>
  );
};

export default AdminExportCsvButton;
